import VGCatalogGrid from "./grid";
import {listener} from "../../../../../modules/vegas/js/util";

listener('click', '[data-vg-toggle="grid"]', (el, e) => {
	new VGCatalogGrid(el).toggle();
}, true);
